import {DespachoState} from './types'
export const state: DespachoState={
    despachos: []
}